import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./SignaturePad.css";

interface SignaturePadProps {
  onSignatureChange: (signatureData: string | null) => void;
  width?: number;
  height?: number;
  backgroundColor?: string;
  penColor?: string;
}

const SignaturePad: React.FC<SignaturePadProps> = ({
  onSignatureChange,
  width = 400,
  height = 200,
  backgroundColor = "#ffffff",
  penColor = "#000000",
}) => {
  const signatureRef = useRef<SignatureCanvas>(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const handleBegin = () => {
    // Signature started
  };

  const handleEnd = () => {
    if (signatureRef.current) {
      const isEmpty = signatureRef.current.isEmpty();
      setIsEmpty(isEmpty);

      if (!isEmpty) {
        const signatureData = signatureRef.current.toDataURL();
        onSignatureChange(signatureData);
      } else {
        onSignatureChange(null);
      }
    }
  };

  const clearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      setIsEmpty(true);
      onSignatureChange(null);
    }
  };

  return (
    <div
      className="signature-pad-container"
      style={{
        border: "2px solid #e0e0e0",
        borderRadius: "8px",
        padding: "1rem",
        backgroundColor: backgroundColor,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1rem",
      }}
    >
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fafafa",
        }}
      >
        <SignatureCanvas
          ref={signatureRef}
          canvasProps={{
            width,
            height,
            className: "signature-canvas",
            style: {
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
            },
          }}
          backgroundColor={backgroundColor}
          penColor={penColor}
          onBegin={handleBegin}
          onEnd={handleEnd}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: "1rem",
          alignItems: "center",
          fontSize: "0.9rem",
          color: "#666",
        }}
      >
        <button
          type="button"
          onClick={clearSignature}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        >
          Clear Signature
        </button>

        <span
          style={{
            color: isEmpty ? "#f44336" : "#4caf50",
            fontWeight: "500",
          }}
        >
          {isEmpty ? "Signature required" : "✓ Signature captured"}
        </span>
      </div>

      <div
        style={{
          fontSize: "0.8rem",
          color: "#666",
          textAlign: "center",
          maxWidth: "300px",
        }}
      >
        Please sign above using your mouse or touch device. Your signature will
        be legally binding and equivalent to a handwritten signature.
      </div>
    </div>
  );
};

export default SignaturePad;
